<template>
  <div :style="{ minWidth: minWidth }" class="entrust_detail">
    <Tabs v-model="currentTabInner" :animated="false">
      <!-- 当前委托 -->
      <TabPane :label="$t('当前委托')" name="current">
        <div class="entrust_title current_title">
          <span class="time title_style">{{ $t('委托时间') }}</span>
          <span class="market title_style">{{ $t('市场') }}</span>
          <span class="side title_style">{{ $t('类别') }}</span>
          <span class="number title_style">{{ $t('委托总量') }}</span>
          <span class="deal title_style">{{ $t('已成交量') }}</span>
          <span class="price title_style">{{ $t('委托价') }}</span>
          <span class="action title_style">{{ $t('操作') }}</span>
        </div>
        <div class="current_entrust_box">
          <ul v-if="currentList.length > 0" class="entrust_ul current_ul">
            <li
              v-for="item in currentList"
              :key="item.entrustId"
              class="entrust_li current_li"
            >
              <span class="time content_style">
                {{ item.time }}
              </span>
              <span class="market content_style">
                {{ `${item.sellCoinName}/${item.buyCoinName}`.toUpperCase() }}
              </span>
              <span
                class="side content_style"
                :class="{
                  type_buy: item.entrustTypeKey === 'MR',
                  type_sell: item.entrustTypeKey === 'MC'
                }"
              >
                {{ item.entrustTypeKey === 'MR' ? $t('买入') : $t('卖出') }}
              </span>
              <span class="number content_style">{{ item.entrustNum }}</span>
              <span class="deal content_style">{{ item.successNum }}</span>
              <span class="price content_style">{{ item.price }}</span>
              <span class="action content_cancel content_style">
                <span
                  v-if="shimOrder !== item.entrustId"
                  @click="handleUserDivestment(item.entrustId)"
                >
                  {{ $t('撤单') }}
                </span>
                <i v-else class="el-icon-loading icon_control"></i>
              </span>
            </li>
            <!-- 查看更多 -->
            <li
              v-if="reverseCurrentMore && currentList.length >= 20"
              class="look_more"
            >
              <p @click="jumpToName('currentHistory', { tab: 'current' })">
                <span>{{ $t('查看更多') }}</span>
                <img src="./../../../../assets/images/jinru.png" alt="" />
              </p>
            </li>
          </ul>
          <NoData
            v-else
            :sceneType="currentSkin === 'black' ? 'night' : 'day'"
          ></NoData>
        </div>
      </TabPane>

      <!-- 历史委托 -->
      <TabPane :label="$t('历史委托')" name="history">
        <div class="entrust_title history_title">
          <span class="time title_style">{{ $t('委托时间') }}</span>
          <span class="market title_style">{{ $t('市场') }}</span>
          <span class="side title_style">{{ $t('类别') }}</span>
          <span class="mode title_style">{{ $t('交易类型') }}</span>
          <span class="money title_style">{{ $t('金额') }}</span>
          <span class="number title_style">{{ $t('委托总量') }}</span>
          <span class="deal title_style">{{ $t('已成交量') }}</span>
          <span class="price title_style">{{ $t('委托价') }}</span>
          <span class="average title_style">{{ $t('成交均价') }}</span>
          <span class="status title_style">{{ $t('状态') }}</span>
        </div>
        <div class="history_entrust_box">
          <ul v-if="historyList.length > 0" class="entrust_ul history_ul">
            <li
              v-for="item in historyList"
              :key="item.entrustId"
              class="entrust_li history_li"
            >
              <span class="time content_style">
                {{ item.time }}
              </span>
              <span class="market content_style">
                {{ `${item.sellCoinName}/${item.buyCoinName}`.toUpperCase() }}
              </span>
              <span
                class="side content_style"
                :class="{
                  type_buy: item.entrustTypeKey === 'MR',
                  type_sell: item.entrustTypeKey === 'MC'
                }"
              >
                {{ item.entrustTypeKey === 'MR' ? $t('买入') : $t('卖出') }}
              </span>
              <span class="mode content_style">
                {{
                  item.orderType === 'limit' ? $t('限价交易') : $t('市价交易')
                }}
              </span>
              <span class="money content_style">{{ item.totalMoney }}</span>
              <span class="number content_style">
                {{ item.entrustNum }}
              </span>
              <span class="deal content_style">{{ item.successNum }}</span>
              <span class="price content_style">
                {{ item.price }}
              </span>
              <span class="average content_style">
                {{ item.averageAmount }}
              </span>
              <!-- <span class="fee content_style">{{ item.fee }}</span> -->
              <span class="status content_style">{{
                item.states | statusFilter(currentInstance)
              }}</span>
            </li>
            <!-- 查看更多 -->
            <!-- <li
              v-if="reverseHistoryMore && historyList.length > 5"
              class="look_more"
            >
              <p @click="jumpToName('currentHistory', { tab: 'history' })">
                <span>{{ $t('查看更多') }}</span>
                <img src="./../../../../assets/images/jinru.png" alt="" />
              </p>
            </li> -->
          </ul>
          <NoData
            v-else
            :sceneType="currentSkin === 'black' ? 'night' : 'day'"
          ></NoData>
        </div>
      </TabPane>
    </Tabs>

    <!-- 当前委托分页组件 -->
    <Pagination
      v-if="
        currentTotal > currentQuery.offset &&
          currentTabInner === 'current' &&
          showCurrentPage
      "
      class="page_box"
      :total="currentTotal"
      layout="prev, pager, next"
      :page.sync="currentQuery.start"
      :limit.sync="currentQuery.offset"
      @pagination="getCurrentEntrust"
    ></Pagination>

    <!-- 历史委托分页组件 -->
    <Pagination
      v-if="
        historyTotal > historyQuery.offset &&
          currentTabInner === 'history' &&
          showHistoryPage
      "
      class="page_box"
      :total="historyTotal"
      layout="prev, pager, next"
      :page.sync="historyQuery.start"
      :limit.sync="historyQuery.offset"
      @pagination="getHistoryEntrust"
    ></Pagination>
  </div>
</template>
<script>
import {
  userDivestment,
  historyEntrust,
  currentEntrust
} from '@/api/transaction'
import { mapState, mapGetters } from 'vuex'
import EventBus from '@/utils/event-bus'

export default {
  props: {
    minWidth: {
      // 组件最小宽度
      type: String,
      default: '1200px'
    },
    sliceCurrentTotal: {
      // 控制“当前委托”列表显示的条数
      type: Number,
      default: undefined
    },
    sliceHistoryTotal: {
      // 控制“历史委托”列表显示的条数
      type: Number,
      default: undefined
    },
    reverseCurrentMore: {
      // 控制“当前委托” tab 显示隐藏“查看更多”（默认隐藏）
      type: Boolean,
      default: false
    },
    reverseHistoryMore: {
      // 控制“历史委托” tab 显示隐藏“查看更多”（默认隐藏）
      type: Boolean,
      default: false
    },
    showCurrentPage: {
      // 控制“当前委托” tab 显示隐藏分页组件（默认隐藏）
      type: Boolean,
      default: true
    },
    showHistoryPage: {
      // 控制“历史委托” tab 显示隐藏分页组件（默认隐藏）
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentInstance: this,
      currentLoading: null,
      historyLoading: null,
      currentTabInner: 'current', // tabs 组件当前活跃的 tab
      shimOrder: '',
      currentList: [],
      historyList: [],
      currentTotal: 0,
      historyTotal: 0,
      currentQuery: {
        start: 1,
        offset: this.sliceCurrentTotal
      },
      historyQuery: {
        start: 1,
        offset: this.sliceHistoryTotal
      }
    }
  },
  computed: {
    ...mapState({
      currentSkin: (state) => state.transaction.currentSkin
    }),
    ...mapGetters(['tradingPairId'])
  },
  watch: {
    currentTabInner: {
      handler(newVal) {
        const action = {
          current: () => {
            this.currentQuery.start = 1
            this.getCurrentEntrust()
          },
          history: () => {
            this.historyQuery.start = 1
            this.getHistoryEntrust()
          }
        }[newVal]
        action()
      },
      immediate: true
    },
    tradingPairId() {
      const action = {
        current: () => {
          this.currentQuery.start = 1
          this.getCurrentEntrust()
        },
        history: () => {
          this.historyQuery.start = 1
          this.getHistoryEntrust()
        }
      }[this.currentTabInner]
      action()
    }
  },
  mounted() {
    EventBus.$on('getCurrentTransaction', () => {
      if (this.currentTabInner === 'current') {
        this.getCurrentEntrust()
      }
    })
  },
  methods: {
    jumpToName(name, params) {
      this.$router.push({ name: name, params: params })
    },
    // 用户撤单
    async handleUserDivestment(entrustId) {
      this.shimOrder = entrustId
      await userDivestment({ entrustId, marketId: this.tradingPairId }).finally(
        () => {
          this.shimOrder = ''
        }
      )
      this.$Message.success(this.$t('操作成功'))
      if (this.currentTabInner === 'current') {
        this.getCurrentEntrust() // 获取最新当前交易记录
      }
    },
    // 获取当前交易记录
    async getCurrentEntrust() {
      this.currentLoading = this.$loading({
        target: '.current_entrust_box',
        duration: 0,
        background:
          this.currentSkin === 'black'
            ? 'rgba(19, 22, 37, 1)'
            : 'rgba(255, 255, 255, 1)'
      })
      try {
        const { start, offset } = this.currentQuery
        const { item, count } = await currentEntrust({
          start: start - 1,
          offset,
          marketId: this.tradingPairId
        })
        this.currentTotal = count
        this.currentList = item
      } catch {
        this.currentTotal = 0
        this.currentList = []
      } finally {
        this.currentLoading.close()
      }
    },
    // 获取历史交易记录
    async getHistoryEntrust() {
      console.log(this.currentSkin === 'black')
      this.historyLoading = this.$loading({
        target: '.history_entrust_box',
        duration: 0,
        background:
          this.currentSkin === 'black'
            ? 'rgba(19, 22, 37, 1)'
            : 'rgba(255, 255, 255, 1)'
      })
      try {
        const { start, offset } = this.historyQuery
        const { item, count } = await historyEntrust({
          start: start - 1,
          offset,
          marketId: this.tradingPairId
        })
        this.historyTotal = count
        this.historyList = item
      } catch {
        this.historyTotal = 0
        this.historyList = []
      } finally {
        this.historyLoading.close()
      }
    }
  },
  filters: {
    statusFilter(status, instance) {
      switch (status) {
        case 'JYZ':
          return instance.$t('交易中')
        case 'YWC':
          return instance.$t('已完成')
        case 'YCX':
          return instance.$t('已撤销')
        case 'BFCH':
          return instance.$t('部分成交')
      }
    }
  }
}
</script>
<style lang="less" scoped>
// 混入样式
.mixin_list(@time, @market, @side, @percent: 0%, @mode: 0%, @money: 0%, @number, @deal, @price, @average, @fee: 0%, @status, @action: 0%) {
  .time {
    width: @time;
    text-align: left;
  }
  .market {
    width: @market;
  }
  .side {
    width: @side;
  }
  .percent {
    width: @percent;
  }
  .mode {
    width: @mode;
  }
  .money {
    width: @money;
  }
  .number {
    width: @number;
  }
  .deal {
    width: @deal;
  }
  .price {
    width: @price;
  }
  .average {
    width: @average;
  }
  .fee {
    width: @fee;
  }
  .status {
    width: @status;
  }
  .action {
    width: @action;
  }
}
.entrust_detail {
  position: relative;
  min-height: 100%;
  background: @contentBgColor2;
  .entrust_title {
    margin-top: 4px;
    margin-bottom: 5px;
  }
  .entrust_title,
  .entrust_ul > .entrust_li {
    padding: 0 70px 0 52px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .title_style {
      font-size: 14px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      color: @textColor2;
      line-height: 20px;
      text-align: right;
    }
    .content_style {
      font-size: 14px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      color: @textColor3;
      line-height: 20px;
      text-align: right;
    }
    .content_cancel {
      color: rgba(66, 179, 250, 1);
      cursor: pointer;
    }
    .icon_control {
      margin-right: 8px;
    }
    // 动态控制字体颜色
    .type_buy {
      color: rgba(65, 179, 126, 1);
    }
    .type_sell {
      color: rgba(206, 68, 68, 1);
    }
  }
  .history_entrust_box,
  .current_entrust_box {
    min-height: 240px;
    .entrust_ul {
      padding-bottom: 40px;
      .entrust_li {
        padding-top: 5px;
        padding-bottom: 5px;
      }
      .entrust_li:hover {
        background: @hoverBgColor;
      }
      // 查看更多
      .look_more {
        margin-top: 35px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        p {
          height: 30px;
          font-size: 12px;
          font-family: PingFangSC-Regular, 'PingFang SC';
          font-weight: 400;
          color: rgba(66, 179, 250, 1);
          line-height: 30px;
          cursor: pointer;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
  // 分页组件
  .page_box {
    // margin-top: 60px;
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .current_title,
  .current_ul > .current_li {
    .mixin_list(
      @time: 170px; @market: 6%; @side: 6.5%; @mode: 10%; @percent: 9.5%;
        @number: 9.5%; @deal: 9.5%; @price: 9.5%; @average: 9.5%; @status: 8%;
        @action: 8%;
    );
  }
  .history_title,
  .history_ul > .history_li {
    .mixin_list(
      @time: 170px; @market: 7.21%; @side: 6.5%; @mode: 10%; @money: 12%;
        @number: 9.5%; @deal: 9.5%; @price: 9.5%; @average: 9.5%; @fee: 9.5%;
        @status: 8%;
    );
  }
}

@media screen and (max-width: 1620px) {
  .current_title,
  .current_ul > .current_li {
    .mode.title_style {
      display: none;
    }
    .mode.content_style {
      display: none;
    }
    .mixin_list(
      @time: 180px; @market: 5.62%; @side: 6.6%; @percent: 9.29%; @number: 10%;
        @deal: 10%; @price: 11.24%; @average: 16.04%; @status: 10%; @action:
        10%;
    );
  }
  .history_title,
  .history_ul > .history_li {
    .mode.title_style {
      display: none;
    }
    .mode.content_style {
      display: none;
    }
    .mixin_list(
      @time: 170px; @market: 7.21%; @side: 6.74%; @money: 12.8%; @number: 11%;
        @deal: 11%; @price: 11%; @average: 11%; @fee: 10%; @status: 8%;
    );
  }
}
</style>
